import { createStore, applyMiddleware, Middleware } from "redux";
import rootReducer from "./reducers/rootReducer";
import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import applySagas from "./saga";

const sagaMiddleware = createSagaMiddleware();
const logger: Middleware = createLogger({ collapsed: true }) as Middleware;

const store = createStore(rootReducer, applyMiddleware(logger, sagaMiddleware));

applySagas(sagaMiddleware);

export default store;
